var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticTraveling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2502 14.5003H9V16L8.2502 16.0003V14.5003Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5L11.7502 14.5003V16.0003L11 16V14.5Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2502 14.5003H11.7502C14.0418 11.4194 17 11.6084 17 7.0504C17 3.70803 13.8647 1 10 1C6.13305 1 3 3.70803 3 7.0504C3 11.6084 5.95811 11.4194 8.2502 14.5003Z",
    fill: "#0083FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5C12.6041 11.4192 14.9002 11.6084 14.9002 7.0504C14.9002 3.70803 12.7053 1 10 1C7.29317 1 5.10023 3.70803 5.10023 7.0504C5.10023 11.6084 7.39556 11.4194 9 14.5003L11 14.5Z",
    fill: "#0083FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 14.5C11.5021 11.4192 12.45 11.6084 12.45 7.0504C12.45 3.70803 11.3526 1 10 1C8.64656 1 7.55 3.70803 7.55 7.0504C7.55 11.6084 8.49778 11.4192 9.3 14.5L10.7 14.5Z",
    fill: "#0083FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90028 16.375C7.90028 15.9608 8.21369 15.625 8.60028 15.625H11.4003C11.7869 15.625 12.1003 15.9608 12.1003 16.375V18.25C12.1003 18.6642 11.7869 19 11.4003 19H8.60028C8.21369 19 7.90028 18.6642 7.90028 18.25V16.375Z",
    fill: "#0083FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 16C7.55 15.7929 7.7067 15.625 7.9 15.625H12.1C12.2933 15.625 12.45 15.7929 12.45 16C12.45 16.2071 12.2936 16.375 12.1003 16.375H7.90028C7.70698 16.375 7.55 16.2071 7.55 16Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticTraveling);
export default __webpack_public_path__ + "static/media/domesticTraveling.09869bf9.svg";
export { ForwardRef as ReactComponent };